<template>
  <Layout>
    <DsIslandsContainer>
      <DsIsland align-center>
        <DsUnavailable :title="message" illustration="status-service-error">
        </DsUnavailable>
        <div class="mx-auto mt-spacing-400">
          <DsButton class="min-w-[192px]" size="medium" @click="onClick">
            <div class="label-600-soft">
              {{ 'unavailable:btn' | translate }}
            </div>
          </DsButton>
        </div>
      </DsIsland>
    </DsIslandsContainer>
  </Layout>
</template>
<script setup>
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import { DsIsland, DsIslandsContainer, DsUnavailable } from '@ds/vue2';
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import { computed, onBeforeUnmount, onMounted } from 'vue'
import translate from '@/filters/translate.filter'
import useStore from '@/composables/useStore'
import useHeader from '@/composables/useHeader';
import Layout from '@/components/ui/Layout/Layout.vue'
const store = useStore()
const { setTitle, setBackFn } = useHeader()
setTitle(translate('title:goldkid'))
setBackFn(() => {
  window.location.href = process.env.VUE_APP_BASE_URL
})
const message = computed(() => {
  return getMessageFromUrl() || store.getters["goldkidProcess/getErrorText"] || translate('error:text')
})
const getMessageFromUrl = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  return urlSearchParams.get('message')
}
const onClick = () => {
  window.location.href = process.env.VUE_APP_BASE_URL
}

onMounted(() => {
  eventBus.$emit('kaspiLoading', false)
  sendAnalyticEvent('online_child_gold_service_error', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    error_code: [],
    error_text: [message.value]
  })
})

onBeforeUnmount(() => {
  sendAnalyticEvent('online_child_gold_service_error', {
    stage: ['finish']
  })
})

</script>
